/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var o;!function(o){o[o.Color=0]="Color",o[o.Depth=1]="Depth",o[o.Normal=2]="Normal",o[o.Shadow=3]="Shadow",o[o.Highlight=4]="Highlight",o[o.Draped=5]="Draped",o[o.Occlusion=6]="Occlusion",o[o.Alpha=7]="Alpha",o[o.COUNT=8]="COUNT"}(o||(o={}));export{o as ShaderOutput};
